'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import TestimonialsSection from './TestimonialsSection';

const HomepageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <>
      <HeroSection isHydrated={isHydrated} />
      <TestimonialsSection isHydrated={isHydrated} />
    </>
  );
};

export default HomepageInteractive;